import * as React from 'react'
import { FunctionComponent } from 'react'
import Svg, { G, Mask, Path } from 'react-native-svg'

type ValuePropOnDemandProps = {
  width?: number
  height?: number
}

export const ValuePropOnDemand: FunctionComponent<ValuePropOnDemandProps> = ({ width = 57, height = 56 }) => {
  return (
    <Svg width={width} height={height} viewBox='0 0 57 56' fill='none'>
      <Path
        d='M28.1968 0.00952148C24.3314 0.00952148 20.5811 0.672387 17.0498 1.97931C8.64285 5.09555 2.73238 12.0042 0.833422 20.9335C-0.421486 26.7554 -0.261026 32.1403 1.32697 37.3879C3.3543 44.0896 8.33078 49.7411 14.9805 52.8927C18.2815 54.4608 22.0739 55.3561 26.2503 55.553C26.787 55.5774 27.3326 55.5907 27.8748 55.5907C31.2257 55.5907 34.5964 55.1314 37.8942 54.2262C38.1476 54.1631 38.3888 54.0978 38.6433 54.0226C41.6069 53.155 44.2738 51.7828 46.5557 49.9491C49.0334 47.9694 51.0729 45.4596 52.6111 42.4938C52.9143 41.9095 53.2043 41.2942 53.5241 40.5583C55.2836 36.4727 56.1335 31.899 55.983 27.3265C55.9122 25.3047 55.6112 23.1556 55.091 20.9335C54.2345 17.3281 52.838 13.9375 51.0519 11.1222C50.5628 10.3664 50.1135 9.73119 49.6686 9.16017C46.4583 5.0192 41.4564 2.11321 35.2084 0.760917C32.9133 0.262938 30.5539 0.010628 28.1979 0.010628L28.1968 0.00952148Z'
        fill='white'
      />
      <Mask
        id='a'
        style={{
          maskType: 'luminance',
        }}
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={57}
        height={56}
      >
        <Path
          d='M28.21.195c-3.866 0-7.616.662-11.147 1.97C8.656 5.28 2.745 12.188.846 21.118-.409 26.94-.248 32.325 1.34 37.573c2.027 6.702 7.004 12.353 13.653 15.505 3.301 1.568 7.094 2.463 11.27 2.66.537.024 1.082.038 1.625.038 3.35 0 6.721-.46 10.02-1.365.252-.063.494-.128.748-.203 2.964-.868 5.63-2.24 7.913-4.074 2.477-1.98 4.517-4.49 6.055-7.455.303-.584.593-1.2.913-1.936 1.76-4.085 2.61-8.659 2.459-13.232-.07-2.021-.372-4.17-.892-6.392-.856-3.606-2.253-6.996-4.04-9.812a27.216 27.216 0 00-1.383-1.962c-3.21-4.14-8.212-7.047-14.46-8.399a33.125 33.125 0 00-7.01-.75L28.21.195z'
          fill='#fff'
        />
      </Mask>
      <G mask='url(#a)'>
        <Path
          d='M35.234 30.59c1.137-2.514 1.06-6.207-.584-8.492-1.142-1.586-3.384-2.81-5.345-3.016-2.048-.215-4.228-.051-6.026.973-1.58.9-2.917 2.244-3.646 3.9a7.552 7.552 0 00-.623 3.413c.119 2.327 1.218 4.712 3.237 5.979 2.438 1.53 5.736 2.17 8.504 1.174 1.708-.614 3.67-2.135 4.483-3.932z'
          fill='#FFA338'
        />
        <Path
          d='M35.66 16.53l2.21-3.106c.29-.407.059-1.059-.318-1.295-.455-.284-.921-.07-1.212.34l-2.21 3.105c-.29.407-.059 1.06.318 1.296.455.284.921.069 1.212-.34zM39.758 21.75a29.032 29.032 0 013.735-2.105c1.16-.551.122-2.08-1.04-1.527a32.383 32.383 0 00-4.153 2.38c-.438.295-.36.942 0 1.25.433.372 1.018.296 1.457 0l.001.002zM26.836 14.124c.054-1.416.11-2.833.163-4.25.045-1.168-1.79-1.165-1.835 0-.054 1.417-.11 2.834-.163 4.25-.045 1.168 1.79 1.166 1.835 0zM14.171 14.355c1 1.39 2.117 2.72 2.985 4.188.618 1.044 2.33.11 1.712-.937-.869-1.468-1.985-2.8-2.985-4.187-.71-.985-2.428-.057-1.712.936zM8.919 25.66l4.162.337c.495.04.919-.41.919-.829 0-.482-.423-.788-.919-.828l-4.162-.338c-.495-.04-.919.409-.919.828 0 .482.423.789.919.83zM10.417 34.84l3.136-2.033c1.044-.678.068-2.323-.975-1.648s-2.09 1.356-3.135 2.033c-1.035.67-.069 2.323.974 1.648z'
          fill='#FFC03C'
        />
        <Path
          d='M47.897 30.735c-.06.52-.121 1.04-.185 1.561-.138 1.102-.242 2.25-.455 3.33-.111.566-.334 1.074-.775 1.284-.489.233-.888-.031-1.316-.33a80.595 80.595 0 01-4.492-3.39 1.402 1.402 0 01-.425-.605c-.494-.576-.197-1.78.395-2.071a83.92 83.92 0 014.966-2.229c.808-.336 1.912-.638 2.307.712.165.564.044 1.169-.02 1.74v-.002z'
          fill='#7FB04D'
        />
        <Path
          d='M16.561 46.763c2.805-2.469 6.835-5.862 10.907-3.953.91.427 1.753.968 2.705 1.315.952.347 2.007.39 3.018.211 2.107-.375 3.81-1.767 5.241-3.222 1.809-1.837 3.55-3.737 5.323-5.608.783-.826-.491-2.062-1.278-1.232-1.596 1.686-3.188 3.375-4.789 5.056-1.354 1.423-2.837 2.911-4.88 3.307-2.044.396-3.6-1.132-5.425-1.736-2.044-.677-4.298-.315-6.237.496-2.238.937-4.08 2.566-5.86 4.134-.861.758.419 1.987 1.277 1.232h-.002z'
          fill='#7FB04D'
        />
      </G>
    </Svg>
  )
}
